import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import RedirectSelector from '../../../../shared/ui-builder/redirect-selector/Redirect-Selector';
import ColorPicker from '../../../../shared/ui-builder/color-picker/Color-Picker';
import CustomUiBuilderTextField from '../../../../shared/form-controls/custom-ui-builder-text-field/Custom-UI-Builder-Text-Field';
import { CAROUSEL_W_DESCRIPTION } from '../../../../constants/UiBuilderConst';
import HotelModuleSelector from '../../../../shared/ui-builder/hotel-module-selector/Hotel-Module-Selector';
import ModuleIdSelector from '../../../../shared/ui-builder/module-id-selector/Module-Id-Selector';
import { Add } from '@material-ui/icons';
import ViewAllSelector from '../../../../shared/ui-builder/view-all-selector/View-All-Selector';
import DraggableTabsList from '../../../../shared/draggable-tabs-list/Draggable-Tabs-List';
import MediaSelector from '../../../../shared/ui-builder/media-selector/Media-Selector';

//2F Carousal with description
const CarouselWithDescription = (props) => {
  const { onItemChange, config, groupId, handleError, componentNdx } = props;
  const [backgroundColor, setBackgroundColor] = useState(
    config.backgroundColor ? config.backgroundColor : '#8f8f8f',
  );
  const [hotelModule, setHotelModule] = useState('');
  const initialSlide = [
    {
      id: `slide_1`,
      label: `Slide 1`,
      imgURL: null,
      titleH3: '',
      redirectLink: {
        connection: '',
        linkId: '',
        isActive: false,
      },
      shadowOverlay: false,
      loopPlayBack: false,
      isVideo: false,
      videoURL: null,
    },
    {
      id: `slide_2`,
      label: `Slide 2`,
      imgURL: null,
      titleH3: '',
      redirectLink: {
        connection: '',
        linkId: '',
        isActive: false,
      },
      shadowOverlay: false,
      loopPlayBack: false,
      isVideo: false,
      videoURL: null,
    },
    {
      id: `slide_3`,
      label: `Slide 3`,
      imgURL: null,
      titleH3: '',
      redirectLink: {
        connection: '',
        linkId: '',
        isActive: false,
      },
      shadowOverlay: false,
      loopPlayBack: false,
      isVideo: false,
      videoURL: null,
    },
    {
      id: `slide_4`,
      label: `Slide 4`,
      imgURL: null,
      titleH3: '',
      redirectLink: {
        connection: '',
        linkId: '',
        isActive: false,
      },
      shadowOverlay: false,
      loopPlayBack: false,
      isVideo: false,
      videoURL: null,
    },
  ];
  const addNewSlide = {
    id: '',
    label: '',
    imgURL: null,
    titleH3: '',
    redirectLink: {
      connection: '',
      linkId: '',
      isActive: false,
    },
    shadowOverlay: false,
    loopPlayBack: false,
    isVideo: false,
    videoURL: null,
  };
  const [slidesList, setSlidesList] = useState(
    config.slides && config.slides.length
      ? config.slides.map((e, index) => {
          return {
            ...e,
            id: `slide_${index + 1}`,
            label: `Slide ${index + 1}`,
          };
        })
      : initialSlide,
  );
  const [activeTabIndex, setActveTabIndex] = useState(0);
  const [activeTabContent, setActveTabContent] = useState(slidesList[0]);
  const [viewAll, setViewAll] = useState(
    config?.viewAll ? config.viewAll : { isActive: true, linkId: '' },
  );
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [h2Title, setH2Title] = useState(config.titleH2 || '');
  const [description, setDescription] = useState(config.description || '');
  const [error, setError] = useState(null);
  const [hotelSubModuleName, setHotelSubModuleName] = useState([]);
  const [isSwapEnabled, setIsSwapEnabled] = useState(false);
  const maxSlidesCount = 20;

  useEffect(() => {
    const currSlider = slidesList?.map((sliderValue, ndx) => {
      if (!sliderValue.titleH3) {
        const subModule = hotelSubModuleName.find((val) => val.index === ndx);
        return { ...sliderValue, titleH3: subModule?.name };
      }
      return { ...sliderValue };
    });
    onItemChange({
      componentName: CAROUSEL_W_DESCRIPTION,
      config: {
        backgroundColor: backgroundColor,
        titleH2: h2Title,
        description: description || '',
        slides: currSlider.map(({ id, label, ...keepAttrs }) => keepAttrs),
        viewAll: viewAll,
      },
    });
  }, [backgroundColor, slidesList, h2Title, description, hotelModule, viewAll, isSwapEnabled]);
  useEffect(() => {
    if (handleError && handleError.length > 0) {
      setIsSwapEnabled(false);
      const currError = handleError.find(
        (getError) => getError.pos === componentNdx && getError.id === CAROUSEL_W_DESCRIPTION,
      );
      if (currError && currError.slides.length > 0) {
        const sliderNdx = Math.min.apply(
          Math,
          currError.slides.map((o) => o.pos),
        );
        setActveTabIndex(sliderNdx);
        setActveTabContent(slidesList[sliderNdx]);
      }
      setError(currError ?? null);
    }
  }, [handleError]);

  const setErrorField = (field, val) => {
    if (field !== 'redirect') {
      const trimmed = typeof val === 'string' ? val?.trim() : val;
      return trimmed ? '' : 'required';
    }
    if (val?.type) return '';
    return 'required';
  };

  const handleTabData = (val, slideContent, field, moduleName) => {
    const thisErr = setErrorField(field, val);
    const newSlidesErr = slidesList?.map((_, idx) => {
      const prev = error?.slides?.find((e) => e?.pos === idx) || { pos: idx };
      return idx === activeTabIndex ? { ...prev, [field]: thisErr } : prev;
    });
    setError({ config: error?.config || {}, slides: newSlidesErr });
    switch (field) {
      case 'titleH3':
        slideContent.titleH3 = val;
        break;
      case 'imgURL':
        slideContent.imgURL = val;
        break;
      case 'redirect':
        slideContent.redirectLink.connection = val.type;
        slideContent.redirectLink.linkId = val.value;
        break;
      case 'isActive':
        slideContent.redirectLink.isActive = val;
        break;
      case 'viewAll':
        setViewAll({
          ...viewAll,
          linkId: val,
        });
        break;
      case 'viewAllStatus':
        setViewAll({
          ...viewAll,
          isActive: val,
        });
        break;
      case 'isVideo':
        slideContent.isVideo = val;
        break;
      case 'shadowOverlay':
        slideContent.shadowOverlay = val;
        break;
      case 'videoURL':
        slideContent.videoURL = val;
        break;
      case 'loopPlayBack':
        slideContent.loopPlayBack = val;
        break;
      default:
        break;
    }
    setSlidesList(
      slidesList.map((slide, index) => {
        if (index === activeTabIndex) {
          return slideContent;
        } else {
          return slide;
        }
      }),
    );
  };

  const onTabChange = (e, value) => {
    setActveTabIndex(value);
    setActveTabContent(slidesList[value]);
  };

  const onColorChange = (color) => {
    setBackgroundColor(color);
  };

  const onChangeH1 = (val) => {
    const titleErr = setErrorField('titleH2', val);
    setError({
      config: { ...error?.config, titleH2: titleErr },
      slides: error?.slides || [],
    });
    setH2Title(val);
  };

  const onChangeDescription = (e) => {
    if (error) {
      const currError = { ...error };
      const currConfigError = {
        ...currError.config,
        description: setErrorField('description', e),
      };
      currError.config = currConfigError;
      setError(currError);
    }
    setDescription(e);
  };

  const hasError = (key, isReturnString = false) => {
    const hasSliderError = error?.slides?.find(
      (errorSlider) =>
        errorSlider.pos === activeTabIndex &&
        (errorSlider[key] === 'required' || errorSlider[key] === 'validUrl' || errorSlider[key] === 'safeDomain'),
    );
    if (isReturnString && hasSliderError && key === 'videoURL') return hasSliderError?.videoURL;
    if (hasSliderError) return true;
    return false;
  };

  const AddNewSlide = (e) => {
    if (slidesList.length < maxSlidesCount) {
      const tempSlidesList = [...slidesList];
      addNewSlide.id = `slide_${slidesList.length + 1}`;
      addNewSlide.label = `Slide ${slidesList.length + 1}`;
      tempSlidesList.push(addNewSlide);
      setSlidesList(tempSlidesList);
      setActveTabIndex(tempSlidesList.length - 1);
      setActveTabContent(tempSlidesList[tempSlidesList.length - 1]);
    }
  };

  const removeSlide = (e) => {
    if (slidesList.length > 1) {
      const tempSlidesList = [...slidesList];
      tempSlidesList.splice(activeTabIndex, 1);
      setSlidesList(tempSlidesList);
      if (activeTabIndex === tempSlidesList.length) {
        setActveTabIndex(tempSlidesList.length - 1);
        setActveTabContent(tempSlidesList[tempSlidesList.length - 1]);
      } else {
        setActveTabContent(tempSlidesList[activeTabIndex]);
      }
    }
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const newTabs = slidesList;
    const draggedTab = newTabs.splice(result.source.index, 1)[0];
    newTabs.splice(result.destination.index, 0, draggedTab);
    setActveTabIndex(result.destination.index);
    setActveTabContent(draggedTab);
    setSlidesList(newTabs);
    setIsSwapEnabled(true);
    const currSlider = slidesList?.map((sliderValue, ndx) => {
      if (!sliderValue.titleH3) {
        const subModule = hotelSubModuleName.find((val) => val.index === ndx);
        return { ...sliderValue, titleH3: subModule?.name };
      }
      return { ...sliderValue };
    });
    onItemChange({
      componentName: CAROUSEL_W_DESCRIPTION,
      config: {
        backgroundColor: backgroundColor,
        titleH2: h2Title,
        description: description,
        slides: currSlider.map(({ id, label, ...keepAttrs }) => keepAttrs),
        viewAll: viewAll,
      },
    });
  };

  return (
    <>
      <div className='row my-2 mx-1'>
        <div className='col-md-10'>
          <CustomUiBuilderTextField
            label='H2 Title'
            required={true}
            className='col-md-12'
            value={h2Title}
            onChangeInput={(e) => onChangeH1(e.target.value)}
            maxLength={100}
            isAdornment={true}
            endAdornment={true}
            error={!isSwapEnabled && error?.config?.titleH2 === 'required' ? true : false}
          />
          <CustomUiBuilderTextField
            label='Description'
            required={false}
            className='col-md-12'
            value={description}
            onChangeInput={(e) => onChangeDescription(e.target.value)}
            maxLength={100}
            isAdornment={true}
            endAdornment={true}
            error={!isSwapEnabled && error?.config?.description === 'required' ? true : false}
          />
          <div className='col-md-12 background-color-titleH2 mb-2'>Background Color</div>
          <div
            className='color-preview d-flex justify-content-center align-items-center shadow mb-1'
            style={{ backgroundColor: backgroundColor, cursor: 'pointer' }}
            onClick={() => setShowColorPicker(!showColorPicker)}
          >
            <span className='color-preview-label'>{backgroundColor}</span>
          </div>
          <div className='row mt-4 mb-3'>
            <div className='col-md-12 slide-tabs d-flex horizontal-scroll-styled pb-2'>
              <DraggableTabsList
                onDragEnd={onDragEnd}
                tabs={slidesList}
                onTabChange={onTabChange}
                activeTabIndex={activeTabIndex}
              />
              <div className='ms-2'>
                <Button
                  disabled={slidesList.length >= maxSlidesCount}
                  variant='outlined'
                  size='medium'
                  color='secondary'
                  onClick={(e) => AddNewSlide(e)}
                >
                  <Add />
                </Button>
              </div>
            </div>
            <div className='col-md-12 pe-1 mt-3'>
              <div className='d-flex justify-content-between px-3 py-2 remove-slide-div'>
                <div>Slide {activeTabContent?.id?.split('_')[1]}</div>
                <div className='text-underlined pointer' onClick={(e) => removeSlide(e)}>
                  Remove
                </div>
              </div>
              <div className='col-md-12'>
                <CustomUiBuilderTextField
                  label='H3 Title'
                  required={true}
                  className='col-md-12 mt-3'
                  value={activeTabContent.titleH3}
                  onChangeInput={(e) => handleTabData(e.target.value, activeTabContent, 'titleH3')}
                  error={
                    !isSwapEnabled && error?.slides[activeTabIndex]?.titleH3 === 'required'
                      ? true
                      : false
                  }
                  maxLength={100}
                  isAdornment={true}
                  endAdornment={true}
                />
                <div className='col-md-12 mt-4'>
                  <MediaSelector
                    groupId={groupId}
                    titleH2={'Image'}
                    height={220}
                    width={330}
                    matrix={'px'}
                    handleTabData={handleTabData}
                    activeTabContent={activeTabContent}
                    isSwapEnabled={isSwapEnabled}
                    hasError={hasError}
                    setIsSwapEnabled={setIsSwapEnabled}
                    ratio={'3:2'}
                  />
                </div>
                <div className='col-md-12 mt-4'>
                  <RedirectSelector
                    onValueChange={(e) => handleTabData(e, activeTabContent, 'redirect')}
                    redirectType={activeTabContent.redirectLink.connection}
                    value={activeTabContent.redirectLink.linkId}
                    onRedirectChange={(e) => {
                      handleTabData(e, activeTabContent, 'isActive');
                    }}
                    isActive={activeTabContent.redirectLink.isActive}
                    error={!isSwapEnabled && hasError('redirect')}
                  />
                </div>
                <div className='col-md-12 mt-4'>
                  <ViewAllSelector
                    onValueChange={(e) => handleTabData(e, activeTabContent, 'viewAll')}
                    value={viewAll.linkId}
                    onViewAllStatusChange={(e) => {
                      handleTabData(e, activeTabContent, 'viewAllStatus');
                    }}
                    isActive={viewAll.isActive}
                    isRequired={viewAll.isActive ? true : false}
                    error={
                      !isSwapEnabled &&
                      viewAll.linkId === '' &&
                      error?.config?.viewAll === 'required'
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showColorPicker && (
        <ColorPicker
          backgroundColor={backgroundColor}
          onColorChange={onColorChange}
          showColorPicker={showColorPicker}
          setShowColorPicker={setShowColorPicker}
        />
      )}
    </>
  );
};

export default CarouselWithDescription;
